import React, { useCallback, useEffect, useState } from 'react';
import VideoJS from '@components/common/video/VideoJS';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const BasicVideo = /*#__PURE__*/React.forwardRef(({
  lectureUrl,
  playPIP = false,
  fluid = false,
  isPreviewMode = false
}, ref = null) => {
  const [canPlayVideo, setCanPlayVideo] = useState(false);
  const playerRef = React.useRef(null);
  const [videoSrc, setVideoSrc] = useState(lectureUrl);
  useEffect(() => {
    setVideoSrc(lectureUrl);
  }, [lectureUrl]);
  const convertVideoURL = useCallback(url => {
    const videoExtension = url.slice(-4);
    if (videoExtension.includes('m3u8')) {
      url = url.slice(0, -4);
      url = url + 'mp4';
      setVideoSrc(url);
    } else if (videoExtension.includes('mp4')) {
      url = url.slice(0, -3);
      url = url + 'mov';
      setVideoSrc(url);
    }
    return url;
  }, [setVideoSrc]);
  const baseOptions = {
    fill: true,
    autoplay: false,
    controls: true,
    responsive: false,
    fluid: fluid,
    sources: [{
      src: videoSrc,
      type: 'video/mp4'
    }],
    playbackRates: [0.5, 1, 1.25, 1.5, 1.75, 2]
  };
  const previewModeOptions = {
    autoplay: true,
    controls: false,
    bigPlayButton: false,
    controlBar: false,
    userActions: {
      click: false,
      doubleClick: false,
      hotkeys: false
    },
    muted: true,
    preload: 'auto',
    playsinline: true,
    disablePictureInPicture: true,
    inactivityTimeout: 0
  };
  const videoJsOptions = isPreviewMode ? {
    ...baseOptions,
    ...previewModeOptions
  } : baseOptions;
  const handlePlayerReady = useCallback(player => {
    playerRef.current = player;
    if (isPreviewMode) {
      player.muted(true);
      player.one('loadeddata', () => {
        player.pause();
        if (player.currentTime() > 0) player.currentTime(0);
      });
      player.on('play', () => {
        player.pause();
      });
    }
    player.on('error', () => {
      const videoExtension = videoSrc.slice(-4);
      if (videoExtension.includes('m3u8') || videoExtension.includes('mp4')) {
        convertVideoURL(videoSrc);
      } else {
        setCanPlayVideo(false);
      }
    });
  }, [videoSrc, convertVideoURL, isPreviewMode]);
  useEffect(() => {
    if (!lectureUrl && lectureUrl === '') {
      setCanPlayVideo(false);
    } else {
      setCanPlayVideo(true);
    }
  }, [lectureUrl]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: canPlayVideo && /*#__PURE__*/_jsx("span", {
      className: "w-full h-full video",
      children: /*#__PURE__*/_jsx(VideoJS, {
        options: videoJsOptions,
        onReady: handlePlayerReady,
        onPlay: videoElement => {
          if (playPIP) {
            if (videoElement && 'webkitSetPresentationMode' in videoElement && 'webkitPresentationMode' in videoElement && typeof videoElement.webkitSetPresentationMode === 'function') {
              videoElement.webkitSetPresentationMode(videoElement.webkitPresentationMode === 'picture-in-picture' ? 'inline' : 'picture-in-picture');
            } else videoElement.requestPictureInPicture();
          }
        },
        ref: ref
      })
    })
  });
});
BasicVideo.displayName = 'BasicVideo';
export default /*#__PURE__*/React.memo(BasicVideo);